export const ROLE_PAGES = {
  owner: ['social', 'dashboard', 'walk-ins', 'appointments', 'billing', 'customers', 'beauty-profile', 'service-reminders', 'employees', 'staff-roster', 'inventory', 'payroll', 'packages', 'vip-cards', 'offers', 'marketing', 'reviews', 'reports', 'settings', 'system-config', 'documents', 'users', 'accounts', 'my-performance', 'referrals', 'stylist-directory', 'ledger', 'sop', 'bridal', 'bridal-templates', 'attendance-tracker', 'targets', 'customer-risk', 'service-profitability', 'pricing', 'salon-calendar', 'tasks', 'recognition', 'staff-notes', 'staff-time'],
  receptionist: ['social', 'dashboard', 'walk-ins', 'appointments', 'billing', 'transactions', 'whatsapp', 'customers', 'beauty-profile', 'service-reminders', 'services', 'sop', 'pricing', 'my-performance', 'inventory', 'product-usage', 'packages', 'vip-cards', 'staff-roster', 'ledger', 'bridal', 'attendance-tracker', 'documents', 'salon-calendar', 'tasks', 'reviews', 'staff-notes', 'staff-time'],
  manager: ['social', 'dashboard', 'walk-ins', 'appointments', 'billing', 'transactions', 'whatsapp', 'customers', 'beauty-profile', 'service-reminders', 'employees', 'staff-roster', 'inventory', 'product-usage', 'payroll', 'packages', 'vip-cards', 'offers', 'reviews', 'reports', 'accounts', 'services', 'sop', 'my-performance', 'referrals', 'stylist-directory', 'ledger', 'bridal', 'bridal-templates', 'attendance-tracker', 'documents', 'customer-risk', 'salon-calendar', 'tasks', 'recognition', 'staff-notes', 'staff-time'],
  stylist: ['appointments', 'billing', 'transactions', 'services', 'sop', 'inventory', 'product-usage', 'reports', 'my-performance', 'staff-roster', 'bridal']
};

export const hasAccess = (role, page) => {
  if (role === 'owner' || role === 'superadmin') return true;
  return (ROLE_PAGES[role] || []).includes(page);
};

export const getAccessiblePages = (role) => {
  if (role === 'owner' || role === 'superadmin') return ROLE_PAGES.owner;
  return ROLE_PAGES[role] || [];
};

/*
 * Who may take the salon's data off the premises.
 *
 * An export is a different act from reading a page: the customer list on
 * screen is one salon's working tool, the same list as a file is a portable
 * copy that leaves with whoever downloaded it. The desk needs to look
 * customers up all day and never needs to carry them home.
 *
 * Stylists are included because they see strictly less than the desk does;
 * leaving the file within their reach while denying it to the desk would be
 * a hole rather than a policy.
 */
const NO_EXPORT_ROLES = ['receptionist', 'stylist'];

export const canExport = (role) => {
  if (role === 'owner' || role === 'superadmin') return true;
  return !NO_EXPORT_ROLES.includes(role);
};

/*
 * Who may browse the customer book, as against look somebody up in it.
 *
 * Same distinction as the export above, one step earlier. The desk needs to
 * find the person in front of it and open their page; it has no call to page
 * through thirteen hundred names and numbers, and that list is the asset
 * worth walking out with.
 *
 * The page itself stays open to them — this only decides whether it shows
 * anything before they have typed a name. customerController enforces the
 * same rule on GET /customers, because a list hidden only on screen is not
 * hidden.
 */
const LOOKUP_ONLY_ROLES = ['receptionist'];

export const canBrowseCustomers = (role) => {
  if (role === 'owner' || role === 'superadmin') return true;
  return !LOOKUP_ONLY_ROLES.includes(role);
};

